<template>
  <footer class="footer">
    <div class="footer-center">
      <img
        src="../assets/img/logo_w@2x.png"
        alt=""
        style="object-fit: contain"
      />
      <p>
        版权所有©深圳昌恩智能股份有限公司 ｜
        <a target="_blank" href="http://beian.miit.gov.cn">粤ICP备17113788号</a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
@media screen and (max-width: 1200px) {
  body .footer .footer-center {
    width: 83%;
  }
}
@media screen and (max-width: 1600px) and (min-width: 1200px) {
  body .footer .footer-center {
    width: 83%;
  }
  .footer-center img {
    width: 200px;
    height: 60px;
  }
  .footer-center p {
    font-size: 18px;
  }
}

/* 缩放175% */
/* 宽度小于1200px的非PC样式（例如平板电脑和手机）： */
@media screen and (max-width: 1199px) {
  .footer-center img {
    width: 200px;
    height: 60px;
  }
}

.footer {
  display: flex;
  justify-content: center;
  width: 100%;
  /* height: 100px; */
  height: 100%;
  background: #030e2c;
}

.footer-center {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* width: 1180px; */
  width: 1470px;
  height: 87px;
}
.footer-center img {
  width: 200px;
  height: 40px;
}
.footer-center p {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  opacity: 0.58;
}
.footer-center p a {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue